// Đạo Văn P0 (ITEMS §5.1.1: #1, #4, #10, #14, #18, #19, #20, #22). Hiệu ứng trong trận là của M3;
// ở M2 là data + hiển thị trên đồ. `byLevel` là con số chính của hiệu ứng ở cấp 1 → 5.
import type { DaoGlyphDef } from './types';

export const DAO_GLYPHS: readonly DaoGlyphDef[] = [
  {
    id: 'countercurrent',
    group: 'defiant_heart',
    trigger: 'passive',
    byLevel: [6, 7.5, 9, 10.5, 12],
    sources: ['boss.hoangLangVuong'],
    phase: 'P0',
  },
  {
    id: 'pillSeal',
    group: 'still_light_vase',
    trigger: 'pill_prebattle',
    byLevel: [20, 30, 40, 50, 60],
    sources: ['boss.sonHoMau'],
    phase: 'P0',
  },
  {
    id: 'boneRuneQuake',
    group: 'supreme_bone',
    trigger: 'first_hit_after_dodge',
    byLevel: [30, 40, 50, 60, 70],
    sources: ['boss.thachHauCoVien'],
    phase: 'P0',
  },
  {
    id: 'strangeFireBurn',
    group: 'bronze_ring',
    trigger: 'fire_hit',
    byLevel: [60, 80, 100, 120, 140],
    sources: ['boss.sonHoMau'],
    phase: 'P0',
  },
  {
    id: 'cycleMark',
    group: 'spring_autumn',
    trigger: 'boss_loss',
    byLevel: [3, 4.25, 5.5, 6.75, 8],
    sources: ['boss.nhacTruongThanh'],
    phase: 'P0',
  },
  {
    id: 'swordHeartClarity',
    group: 'fate_eye',
    trigger: 'parry_ok',
    byLevel: [1.5, 1.75, 2, 2.25, 2.5],
    sources: ['boss.nhacTruongThanh'],
    phase: 'P0',
  },
  {
    id: 'karmaReturn',
    group: 'fate_eye',
    trigger: 'parry_ok',
    byLevel: [30, 40, 50, 60, 70],
    sources: ['boss.hoangLangVuong'],
    phase: 'P0',
  },
  {
    id: 'lampShadowBurn',
    group: 'common',
    trigger: 'poise_break',
    byLevel: [80, 110, 140, 170, 200],
    sources: ['boss.trucCoKiep'],
    phase: 'P0',
  },
];

export function glyphDef(id: string): DaoGlyphDef {
  const d = DAO_GLYPHS.find((x) => x.id === id);
  if (!d) throw new RangeError(`unknown dao glyph: ${id}`);
  return d;
}

export function isGlyphId(v: unknown): v is string {
  return typeof v === 'string' && DAO_GLYPHS.some((g) => g.id === v);
}
